import React, { useState, useEffect, useRef } from 'react'
// import { Link } from 'gatsby'
import cn from 'classnames'

import Q1 from '~/assets/svg/q1.svg'
import Q2 from '~/assets/svg/q2.svg'
import Q3 from '~/assets/svg/q3.svg'
import Q4 from '~/assets/svg/q4.svg'
import Q5 from '~/assets/svg/q5.svg'

import s from './styles.module.scss'

const preset = [
  {
    q: 'question_v',
    b: 'break1',
    i: 'question_v',
    c: 'white',
  },
  {
    q: 'question_v',
    b: 'break1',
    i: 'icon1',
    c: 'icon1',
  },
  {
    q: 'question_v',
    b: 'break2',
    i: 'icon2',
    c: 'icon2',
  },
  {
    q: 'question_h',
    b: 'break3',
    i: 'icon3',
    c: 'icon3',
  },
  {
    q: 'question_d',
    b: 'break4',
    i: 'icon4',
    c: 'icon4',
  },
  {
    q: 'question_d',
    b: 'break5',
    i: 'icon5',
    c: 'icon5',
  },
]

const phase: ('q' | 'b' | 'i')[] = ['q', 'b', 'i', 'b']

type Props = {}

const Component: React.FC<Props> = ({}) => {
  const [phaseIndex, setPhaseIndex] = useState(0)
  const presetIndex = useRef(1)
  const shape = useRef(preset[presetIndex.current][phase[phaseIndex]])
  const color = useRef(preset[presetIndex.current].c)
  const timeoutId = useRef(0)

  useEffect(() => {
    return () => clearTimeout(timeoutId.current)
  }, [])

  useEffect(() => {
    timeoutId.current = window.setTimeout(() => {
      const pi = phaseIndex == 3 ? 0 : phaseIndex + 1
      if (pi === 0)
        presetIndex.current =
          presetIndex.current == 5 ? 1 : presetIndex.current + 1

      shape.current = preset[presetIndex.current][phase[pi]]
      color.current = preset[presetIndex.current].c

      setPhaseIndex(pi)
    }, 2000)
  }, [phaseIndex])

  return (
    <div
      className={cn(s.q, {
        [s[`shape_${shape.current}`]]: true,
        [s[`color_${color.current}`]]: true,
      })}
    >
      <Q1 />
      <Q2 />
      <Q3 />
      <Q4 />
      <Q5 />
    </div>
  )
}

export default Component
